export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
}

export const THEME_KEY = 'app-theme' as const;
